import {
  IAccount,
  IAccountBody,
  IAccountQuery,
  IBasePagingRes,
  IChangePasswordBody,
  IUpdateProfileBody,
} from 'src/types';
import { http } from 'src/utils';
import BaseService from './base.service';

export default class AccountService extends BaseService<IAccount, IAccountQuery, IAccountBody> {
  constructor() {
    super('/api/account');
  }

  public async changePassword(body: IChangePasswordBody) {
    const { data } = await http.put<boolean>(`${this.url}/change-pass`, body);
    return data;
  }

  public async profile() {
    const { data } = await http.get<IAccount>(`${this.url}/profile`);
    return data;
  }

  public async updateProfile(body: IUpdateProfileBody) {
    const { data } = await http.put<boolean>(`${this.url}/profile`, body);
    return data;
  }

  public async search(query: IAccountQuery) {
    const { data } = await http.get<IBasePagingRes<IAccount>>(`${this.url}/search`, { params: query });
    return data.data;
  }
}
